<ms-grid-list class="grid-list" *ngIf="grid$ | async as grid" [model]="grid" [hideFavourites]="true" [tracking]="tracking"></ms-grid-list>
